import React from 'react';
import { Typography } from '@doveit/lego';
import { BasicSectionProps } from '../types';
import PageSection from '../../components/page-section/PageSection';
import Markdown from '../../components/markdown/Markdown';
import ArticleMarkdown from '../../components/article-markdown/ArticleMarkdown';

export interface GenericSectionProps extends Omit<BasicSectionProps, 'content'> {
  content: string,
  titleColor?: string,
  backgroundColor?: string,
}

export const GenericSection: React.FC<GenericSectionProps> = ({
  title,
  content,
  titleColor,
  backgroundColor,
}) => (
  <PageSection backgroundColor={backgroundColor}>
    <PageSection.Wrapper>
      {title && (
        <PageSection.Title color={titleColor}>
          <Markdown>
            {title.trim()}
          </Markdown>
        </PageSection.Title>
      )}
      <PageSection.Block noSpacing={!title}>
        <Typography.BODY>
          <ArticleMarkdown>
            {content.trim()}
          </ArticleMarkdown>
        </Typography.BODY>
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default GenericSection;
